export var BANK_CODE;
(function (BANK_CODE) {
    BANK_CODE["BAGAGE22"] = "BOG";
    BANK_CODE["TBCBGE22"] = "TBC";
    BANK_CODE["JSCRGE22"] = "Credo";
    BANK_CODE["ISBKGE22"] = "Isbank";
    BANK_CODE["PAHAGE22"] = "Pasha";
    BANK_CODE["HABGGE22"] = "Halyk";
    BANK_CODE["DISNGE22"] = "Silk";
    BANK_CODE["MIBGGE22"] = "ProCredit";
    BANK_CODE["TCZBGE22"] = "Ziraat";
    BANK_CODE["CRTUGE22"] = "Cartu";
    BANK_CODE["CBASGE22"] = "BSB";
    BANK_CODE["LBRTGE22"] = "Liberty";
    BANK_CODE["TEBAGE22"] = "Tera";
    BANK_CODE["BZENLT22"] = "ZEN";
})(BANK_CODE || (BANK_CODE = {}));
//# sourceMappingURL=bank.js.map